import * as core from '../../../../../../../core'
import * as innovationTracker from '../financial-performance'

export const RESOURCE = {
  payload: {
    alias: 'financial.performance.overview',
    appAlias: innovationTracker.RESOURCE.payload.alias,
    description: 'See an overview of financial performance',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Overview',
    page: { alias: 'financial.performance.overview' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
